import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
import { Head } from '@_/components';
import { useStores } from '#src/state/StoreContext.tsx';

export const Route = createFileRoute('/{-$locale}/_noAuth')({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const { useAuthStore } = context;
    await useAuthStore.getState().checkSession();
  },
  validateSearch: z.object({
    redirect: z.string().trim().nonempty().startsWith('/').optional().catch(undefined)
  }),
  ssr: false
});

function RouteComponent() {
  const { redirect } = Route.useSearch();
  const { useAuthStore } = useStores();
  const isAuthenticated = useAuthStore(state => !!state.session);

  if (isAuthenticated) {
    if (redirect) {
      return <Navigate to={redirect} />;
    }

    return <Navigate to="/{-$locale}" params={prev => ({ locale: prev.locale })} />;
  }

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <Outlet />
    </>
  );
}
